import { DepartmentDto } from "../../autogen/bff-api";

export const organizationHasSeveralDepartments = (org: { departments?: DepartmentDto[] }): boolean =>
  (org.departments ?? []).length > 1;

// BFF Profiles.kt gates PUBLISH on HomeDepartmentPresent: hide an unset one and the draft is stuck.
export const showsHomeDepartment = (
  org: { departments?: DepartmentDto[] },
  homeDepartmentId: string | null | undefined
): boolean => organizationHasSeveralDepartments(org) || !homeDepartmentId;
